import React from "react";
import joinUsImage from '../assets/joinus.png';

export default function JoinUs() {
  return (
    <div className="bg-[#9be56a] py-20 flex items-center justify-center">
      <div className="container mx-auto px-6 lg:px-20 flex flex-col lg:flex-row items-center gap-12">
        
        {/* Left Section - Image */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img 
            src={joinUsImage}
            alt="Carmie Team" 
            className="rounded-lg shadow-lg w-full lg:w-[85%] object-cover"
          />
        </div>

        {/* Right Section - Text */}
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-800">
            Join Us 🚀
          </h2>
          <h3 className="text-2xl lg:text-3xl font-bold text-gray-700 mt-4">
            Our Team
          </h3>
          <p className="text-lg text-gray-700 mt-4 leading-relaxed">
            At <span className="font-semibold">Carmie</span>, we are committed to providing 
            African cities with <span className="font-semibold">accessible and convenient
            automotive services</span> at the touch of a button.
          </p>
          <p className="text-lg text-gray-700 mt-4 leading-relaxed">
            Our platform is tailored to meet the <span className="font-semibold">
            unique needs of African consumers</span>, serving as a comprehensive 
            solution for vehicle maintenance, repairs, and related services. 
          </p>
          <p className="text-lg text-gray-700 mt-4 leading-relaxed">
            Carmie offers a <span className="font-semibold">safe and convenient</span> 
             platform that connects users with <span className="font-semibold">
            trusted mechanics and service providers</span>. This approach fosters 
            a sense of community and stability among our network of automotive 
            professionals.
          </p>
        </div>

      </div>
    </div>
  );
}
